if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}


document.addEventListener("DOMContentLoaded", function() {
  if (!window.location.href.includes("/en")) {
    // Target all labels within the parent div
    let labels = document.querySelectorAll('.shopify_subscriptions_app_block_label_children label');
    
    labels.forEach(label => {
        let nodes = Array.from(label.childNodes); // Convert childNodes to array for easy filtering
        let textNodes = nodes.filter(node => node.nodeType === 3); // Filter text nodes
        
        textNodes.forEach(textNode => {
            let text = textNode.textContent.trim();
            switch (text) {
                case 'Delivery every 2 months':
                    textNode.textContent = 'Lieferung alle 2 Monate - 4% sparen';
                    break;
                case 'Delivery every 3 months':
                    textNode.textContent = 'Lieferung alle 3 Monate - 5% sparen';
                    break;
                case 'Delivery every 4 months':
                    textNode.textContent = 'Lieferung alle 4 Monate - 6% sparen';
                    break;
            }
        });
    });
  } else {
    // Target all labels within the parent div
    let labels = document.querySelectorAll('.shopify_subscriptions_app_block_label_children label');
    
    labels.forEach(label => {
        let nodes = Array.from(label.childNodes); // Convert childNodes to array for easy filtering
        let textNodes = nodes.filter(node => node.nodeType === 3); // Filter text nodes
        
        textNodes.forEach(textNode => {
            let text = textNode.textContent.trim();
            switch (text) {
                case '3 months 3 months':
                    textNode.textContent = ' Delivery every 2 months - save 4%';
                    break;
                case '2 months 2 months':
                    textNode.textContent = ' Delivery every 3 months - save 5%';
                    break;
                case 'Delivery every 4 months':
                  textNode.textContent = ' Delivery every 4 months - save 6%';
                  break;
            }
        });
    });

    var content = document.querySelector('.shopify_subscriptions_app__title').innerHTML;
    if(content.includes('Abonnement-Richtlinien')){
      document.querySelector('.shopify_subscriptions_app__title').innerHTML = 'Subscription Policies';
    }
  }
});
